// Existing production Worker, verified against the product manifest/provider.
// This public destination is shared by the native transport and server boundary.
export const PRODUCTION_API_ORIGIN = 'https://passnote-api-production.wjstks3474.workers.dev';
export const TOSS_API_ORIGINS: readonly string[] = [
  'https://hoedokloop.apps.tossmini.com',
  'https://hoedokloop.private-apps.tossmini.com',
];
